// src/components/Navbar/Navbar.jsx
import React from "react";
import "./Navbar.css";
import logo from "../../images/logo.png";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="container">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
        <ul className="nav-links">
          <li><a href="#hero">Home</a></li>
          <li><a href="#sobre">Sobre Mim</a></li>
          <li><a href="#action">Área de Atuação</a></li>
          <li><a href="#servicos">Serviços</a></li>
          
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
